// extracted by mini-css-extract-plugin
export default {"rangeBox":"range-box_rangeBox__o4JT9","input":"range-box_input__Y+atA"};